var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ml-2",class:_vm.customClass,on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('v-icon',{attrs:{"left":_vm.text?true:false}},[_vm._v(_vm._s(_vm.icon))]),(_vm.text)?_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }